// カテゴリ名付与

document.addEventListener("DOMContentLoaded", function() {
    // data-category 属性を持つ全ての要素を取得
    var elements = document.querySelectorAll('[data-category]');

    elements.forEach(function(element) {
        // 親要素を取得
        var parent = element.parentNode;

        // data-category 属性の値を取得
        var category = element.getAttribute('data-category');

        // 親要素にそのカテゴリ名をクラスとして追加
        parent.classList.add(category);
    });
});

// data-categoryの値をID付与

document.addEventListener('DOMContentLoaded', function() {
    // 'flag-column-menu' クラスを持つ全ての要素を取得
    var elements = document.querySelectorAll('.flag-column-menu');

    elements.forEach(function(element) {
        // 各要素内の img タグを探す
        var imgTag = element.querySelector('img');

        // img タグが存在し、親要素が data-category 属性を持つ場合
        if (imgTag && element.parentElement.dataset.category) {
            // 親要素の data-category の値を親要素の ID として設定
            element.parentElement.id = element.parentElement.dataset.category;
        }
    });
});

// メニューとカテゴリ名にborder付与

window.addEventListener('scroll', function() {
    let activeSection = null;

    // 各セクション（.shopify-section）をループし、スクロール中に可視領域にあるセクションを確認
    document.querySelectorAll('.shopify-section').forEach(section => {
        const rect = section.getBoundingClientRect();
        // セクションが画面の中央付近にある場合
        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
            const sectionClasses = section.classList;
            // メニュー内の各リンクと対応するセクションを紐づけ
            document.querySelectorAll('a.menu-contents').forEach(link => {
                const href = link.getAttribute('href').substring(2); // '#'を除去して対応するクラス名を取得
                if (sectionClasses.contains(href)) {
                    activeSection = href; // アクティブなセクションを更新
                }
            });
        }
    });

    // 以前アクティブだったメニュー項目からボーダーを削除
    document.querySelectorAll('a.menu-contents img.active-border-menu').forEach(img => {
        img.classList.remove('active-border-menu');
    });
    document.querySelectorAll('.flag-column-menu img.active-border').forEach(img => {
        img.classList.remove('active-border');
    });

    // アクティブになったセクションに対応するメニュー項目にボーダーを追加
    if (activeSection) {
        document.querySelectorAll(`a.menu-contents[href='/#${activeSection}'] img`).forEach(img => {
            img.classList.add('active-border-menu');
        });
        document.querySelectorAll(`.${activeSection} .flag-column-menu img`).forEach(img => {
            img.classList.add('active-border');
        });
    }
});

// 英数字のみフォント変更

const nodeIterator = document.createNodeIterator(
    document.getElementById('page-content'), // page-content内の全テキストノードを対象
    NodeFilter.SHOW_TEXT,
    null
);

let currentNode;
// 各テキストノードをループ
while (currentNode = nodeIterator.nextNode()) {
    // 祖先に 'alphabet' クラスを持つ要素がない場合
    if (!hasAncestorWithClass(currentNode, 'alphabet')) {
        let parent = currentNode.parentElement;
        // p または h3 タグを持つ要素、もしくは指定クラスを持つ祖先を見つけるまで親要素を辿る
        while (parent && parent !== document.body) {
            if (parent.tagName === 'P' || parent.tagName === 'H3' || hasNotoClassAncestor(parent)) {
                // 英数字を 'alphabet' クラスで囲む
                const template = document.createElement('template');
                template.innerHTML = currentNode.nodeValue.replace(/(\w+)/g, '<span class="alphabet">$1</span>');
                currentNode.parentElement.insertBefore(template.content, currentNode);
                currentNode.parentElement.removeChild(currentNode);
                break;
            }
            parent = parent.parentElement;
        }
    }
}

// 指定したクラスを持つ祖先があるかチェック
function hasAncestorWithClass(node, className) {
    while (node = node.parentElement) {
        if (node.classList.contains(className)) {
            return true;
        }
    }
    return false;
}

// noto-serif または noto-sans クラスを持つ祖先があるかチェック
function hasNotoClassAncestor(node) {
    while (node = node.parentElement) {
        if (node.classList.contains('noto-serif') || node.classList.contains('noto-sans')) {
            return true;
        }
    }
    return false;
}

// スムーススクロール

if (location.pathname === '/') {
    document.querySelectorAll('a[href^="/#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            // URLからハッシュ（#以降）を抽出
            const hash = this.getAttribute('href').split('#')[1];
            if (hash) {
                const targetId = '#' + hash;
                const targetElement = document.querySelector(targetId);
                if (targetElement) {
                    // スムーススクロールでターゲット要素まで移動
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        });
    });
}

// KV動作

document.addEventListener('DOMContentLoaded', function() {
    // PC用Lottieアニメーションの設定
    const pcAnimation = lottie.loadAnimation({
        container: document.getElementById('pc-lottie'),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: 'https://lottie.host/1f705413-e0e4-45da-ae4a-9d64c874fc27/CJwHNmuQQX.json'
    });

    // スマホ用Lottieアニメーションの設定
    const spAnimation = lottie.loadAnimation({
        container: document.getElementById('sp-lottie'),
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: 'https://lottie.host/f4b74adc-a6b5-40d8-bc42-21fbe981991c/EabJZeFiBp.json'
    });

    // 画面サイズに応じたエンド値を設定する関数
    function getEndValue() {
        const pageWidth = window.innerWidth;
        if (pageWidth > 1024) {
            return "bottom 45%"; // PC用
        } else if (pageWidth > 768 && pageWidth <= 1024) {
            return "bottom 20%"; // タブレット用
        } else {
            return "bottom 30%"; // スマホ用
        }
    }

    // ScrollTriggerの設定を更新する関数
    function updateScrollTrigger() {
        ScrollTrigger.create({
            trigger: '#pc-lottie',
            start: "top 0px",
            end: getEndValue(),
            scrub: true,
            onUpdate: (self) => {
                const frame = Math.floor(pcAnimation.totalFrames * self.progress);
                pcAnimation.goToAndStop(frame, true);
            },
        });

        ScrollTrigger.create({
            trigger: '#sp-lottie',
            start: "top 0px",
            end: getEndValue(),
            scrub: true,
            onUpdate: (self) => {
                const frame = Math.floor(spAnimation.totalFrames * self.progress);
                spAnimation.goToAndStop(frame, true);
            },
        });
    }

    // 初期設定
    updateScrollTrigger();

    // リサイズ時にScrollTriggerを更新
    window.addEventListener('resize', function() {
        // 既存のScrollTriggersを削除
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        updateScrollTrigger();
    });
});
